import { render } from "./Sitemap.vue?vue&type=template&id=032f3778&scoped=true"
import script from "./Sitemap.vue?vue&type=script&lang=js"
export * from "./Sitemap.vue?vue&type=script&lang=js"

import "./Sitemap.vue?vue&type=style&index=0&id=032f3778&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032f3778"]])

export default __exports__